import React, { useEffect, useState } from "react";
import { useDispatchKiosk } from "../../redux";
import { chatbotChangeAction } from "../../redux/Actions";
import { useChatbot } from "../../redux/Hooks";
import { useLocale } from "@davi-ai/retorik-framework"; 
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import type { ChatbotData } from "../../model/Configuration";
import Button from "../Common/Button";
import TextField from "./TextField";
import ResetIcon from "../icons/ResetIcon";

const ChatbotDisplay = () => {
  const locale = useLocale();
  const chatbotData = useChatbot();
  const dispatch = useDispatchKiosk();
  const [size, setSize] = useState<string | undefined>(
    chatbotData?.size?.toString() || undefined
  );
  const [height, setHeight] = useState<string | undefined>(
    chatbotData?.height?.toString() || undefined
  );
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    setHeight(chatbotData?.height?.toString());
    setSize(chatbotData?.size?.toString());
  }, [chatbotData]);

  const handleSizeReset = () => {
    setErrorMessage("");
    setSize(undefined);
  };
  const handleHeightReset = () => {
    setErrorMessage("");
    setHeight(undefined);
  };

  const handleSizeChange = (event: any) => {
    setErrorMessage("");
    if (!parseInt(event.target.value)) {
      setErrorMessage("Please only enter numbers");
    }
    setSize(event.target.value);
  };

  const handleHeightChange = (event: any) => {
    setErrorMessage("");
    if (!parseInt(event.target.value) && event.target.value !== "-") {
      setErrorMessage("Please only enter numbers");
    }
    setHeight(event.target.value);
  };

  const convertToInt = (value: string | undefined) => {
    if (!value) return undefined;
    return parseInt(value) || undefined;
  };

  const handleSave = () => {
    const data = {
      size: convertToInt(size),
      height: convertToInt(height)
    }
    const newSettings: ChatbotData = {...chatbotData, ...data}

    if (!errorMessage) {
      dispatch(chatbotChangeAction(newSettings));
    } else {
      setErrorMessage(`Chatbot display could not be saved: ${errorMessage}`);
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 mt-6">
      <div className="w-full flex items-end gap-2">
        <TextField
          label={translation[locale]?.chatbot.size || translation["fr-FR"].chatbot.size}
          onChange={handleSizeChange}
          value={size}
        />
        <Button onClick={handleSizeReset} label={commonTranslation[locale]?.reset || commonTranslation["fr-FR"].reset}>
          <ResetIcon />
        </Button>
      </div>
      <div className="w-full flex items-end gap-2">
        <TextField
          label={translation[locale]?.chatbot.position || translation["fr-FR"].chatbot.position}
          onChange={handleHeightChange}
          value={height}
        />
        <Button onClick={handleHeightReset} label={commonTranslation[locale]?.reset || commonTranslation["fr-FR"].reset}>
          <ResetIcon />
        </Button>
      </div>
      {errorMessage && (
        <p className="italic text-yellow-300 text-center">{errorMessage}</p>
      )}
      <Button onClick={handleSave} label={commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}>
        {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
      </Button>
    </div>
  );
};

export default ChatbotDisplay;
